import { BarberQuery } from './barber-query';
import { BarberProfileStatisticsQuery } from './barber-statistics-query';
export var endpoints = {
    barberQuery: new BarberQuery(),
    barberProfileStatisticsQuery: new BarberProfileStatisticsQuery(),
};
